import classNames from 'classnames';

import { Wizard } from '../../../components/Wizard/Wizard';
import { useFlag } from '../../../services/launchDarkly';
import { ResetPasswordRedesign } from '../redesign-components/ResetPasswordRedesign/ResetPasswordRedesign';
import { ResetPasswordSuccessRedesign } from '../redesign-components/ResetPasswordSuccessRedesign/ResetPasswordSuccessRedesign';
import { ResetPassword } from '../ResetPassword/ResetPassword';
import { ResetPasswordSuccess } from '../ResetPasswordSuccess/ResetPasswordSuccess';

import { authWizardWrapperStyle } from './constants';
import styles from './RedesignWizard.module.scss';

export default function ResetPasswordWizard() {
  const redesignFlow = useFlag<boolean>('ui_redesign_registration_flow', false);

  const steps = redesignFlow
    ? [ResetPasswordRedesign, ResetPasswordSuccessRedesign]
    : [ResetPassword, ResetPasswordSuccess];

  return (
    <Wizard
      classNameSteps={classNames({
        [styles.redesignFlowSteps]: redesignFlow,
      })}
      classNameStepWrapper={classNames({
        [styles.redesignFlowStepWrapper]: redesignFlow,
      })}
      steps={steps}
      wrapperStyle={authWizardWrapperStyle}
    />
  );
}
